import { PlayerGeoblock } from "/app/libraries/arcana/src/blocks/PlayerGeoblock/index.ts"

import { useUnit } from 'effector-react'
import { $geoblockPlayerTranslation } from './translates'

interface IGeoblockProps {
  smallPlayer?: boolean
  isFullscreen?: boolean
}

export const Geoblock = ({
  smallPlayer = false,
  isFullscreen,
}: IGeoblockProps) => {
  const geoblockPlayerTranslation = useUnit($geoblockPlayerTranslation)

  return (
    <PlayerGeoblock
      title={geoblockPlayerTranslation}
      smallPlayer={smallPlayer}
      isFullscreen={isFullscreen}
    />
  )
}
